import { SwitchButton } from "components/switchButton";
import { Link } from "react-router-dom";
import Button from "components/button";
import { EyeIcon, PencilIcon } from "@heroicons/react/outline";
import { IHomepageCouponItem } from "interfaces";
import { isHaveActionPermission } from "utills/helpers";

interface HomepageCouponTableProps {
  data?: IHomepageCouponItem[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, isActive: boolean) => void;
}

export const HomepageCouponTable = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
  _toggleActive,
}: HomepageCouponTableProps) => {
  return (
    <div className="flow-root">
      <div className="relative inline-block w-full align-middle box-border">
        <table className="w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
          <thead>
            <tr>
              <th scope="col" className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8">
                No
              </th>
              <th scope="col" className="th">
                Coupon code
              </th>
              <th scope="col" className="th">
                Title eng
              </th>
              <th scope="col" className="th">
                Content eng
              </th>
              <th scope="col" className="th">
                Soldout
              </th>
              <th scope="col" className="th">
                Status
              </th>
              <th scope="col" className="th w-28">
                <span className="sr-only">Action</span>
                <p className="">Action</p>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {data.map((item: IHomepageCouponItem, index: number) => (
              <tr key={index}>
                <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                  {(currentPage - 1) * pageSize + 1 + index}
                </td>
                <td className="td">
                  {item.coupon_code}
                </td>
                <td className="td max-w-48 overflow-x-auto">
                  {item.title_en}
                </td>
                <td className="td max-w-48 overflow-x-auto">
                  <p className="whitespace-pre-line">
                    {item.content_en}
                  </p>
                </td>
                <td className="td">
                  {item.is_sold_out ? "Yes" : "No"}
                </td>
                <td className="td overflow-x-auto">
                  <SwitchButton
                    checked={item.is_active}
                    disabled={!isHaveActionPermission("homepage_coupon", "mkt", "edit")}
                    onChange={() => _toggleActive(item.id, item.is_active)}
                  />
                </td>
                <td className="td gap-x-2 py-4 pl-3 pr-4 sm:pr-6 lg:pr-8">
                  <div className="flex items-center gap-x-2">
                    <Link to={`/mkt/homepage-coupon/${item.id}`} className="w-fit">
                      <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                        <EyeIcon className="w-4 h-4 text-black" />
                      </Button>
                    </Link>
                    {isHaveActionPermission(
                      "homepage_coupon",
                      "mkt",
                      "edit"
                    ) ? (
                      <Link
                        to={`/mkt/homepage-coupon/${item.id}/edit`}
                        className="w-fit"
                      >
                        <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                          <PencilIcon className="w-4 h-4 text-black" />
                        </Button>
                      </Link>
                    ) : (
                      <></>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
